import { IconType } from '../icon/Icon';
import { LinkVariant } from '../link/Link';
import { ToastProps } from './Toasts';

export const makeDownloadingToast = (fileCount: number): ToastProps => ({
  duration: 0,
  message: {
    type: 'info',
    description: `<h7><strong>Preparing Download</strong></h7><p>Zipping ${fileCount} file${
      fileCount === 1 ? '' : 's'
    }…</p>`,
    loadingIcon: true,
    actions: [
      {
        label: 'Hide',
        variant: LinkVariant.BUTTON,
        isSmall: true,
        shouldClose: true,
      },
    ],
  },
});

export const makeDownloadedToast = (
  toastProps: ToastProps & { fileName: string; downloadUrl: string }
): ToastProps => ({
  duration: toastProps.duration ?? 10000, // default to 10s if not given
  message: {
    ...(toastProps.message || {
      description: `<h7><strong>Download Ready</strong></h7>
                    <p>Your files are ready to download.</p>`,
    }),
    type: 'success',
    icon: IconType.Available,
    iconCircle: true,
    variant: 'light',
    shouldTurnicate: true,
    actions: [
      {
        variant: LinkVariant.BUTTON,
        icon: { iconType: IconType.Download },
        onClick() {
          // Trigger browser download
          const a = document.createElement('a');
          a.href = toastProps.downloadUrl;
          a.download = toastProps.fileName || '';
          a.target = '_blank';
          document.body.appendChild(a);
          a.click();
          a.remove();
        },
        className: 'etex-toast-download',
      },
      {
        variant: LinkVariant.BUTTON,
        icon: { iconType: IconType.Close },
        shouldClose: true,
      },
    ],
  },
});
